var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglandFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0.000244141H0V15.0004H22.5V0.000244141Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 0H9.84375V6.09372H0V8.90622H9.84375V14.9999H12.6562V8.90622H22.5V6.09372H12.6562V0Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3051 10.1086L22.5 12.9948V10.1086H17.3051Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6957 10.1086L22.5 14.9999V13.6168L16.1854 10.1086H13.6957Z",
    fill: "#0052B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1548 14.9999L13.6957 11.4111V14.9999H20.1548Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6957 10.1086L22.5 14.9999V13.6168L16.1854 10.1086H13.6957Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6957 10.1086L22.5 14.9999V13.6168L16.1854 10.1086H13.6957Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97006 10.1086L0 12.3143V10.1086H3.97006Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80439 10.7305V14.9998H1.12024L8.80439 10.7305Z",
    fill: "#0052B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31463 10.1086L0 13.6168V14.9999L8.80436 10.1086H6.31463Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19499 4.89128L0 2.00513V4.89128H5.19499Z",
    fill: "#0052B4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80436 4.89129L0 0V1.38313L6.31463 4.89129H8.80436Z",
    fill: "#0052B4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34521 0L8.80439 3.58875V0H2.34521Z",
    fill: "#0052B4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80436 4.89129L0 0V1.38313L6.31463 4.89129H8.80436Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80436 4.89129L0 0V1.38313L6.31463 4.89129H8.80436Z",
    fill: "#D80027"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.53 4.89141L22.5001 2.68579V4.89141H18.53Z",
    fill: "#0052B4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6957 4.26933V0H21.3798L13.6957 4.26933Z",
    fill: "#0052B4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1854 4.89129L22.5 1.38313V0L13.6957 4.89129H16.1854Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglandFlag);
export default __webpack_public_path__ + "static/media/england-flag.12463bc3ed8b9f1f86abf8f03477e81f.svg";
export { ForwardRef as ReactComponent };